<template>
    <v-content :style="widthValue === 0 && mini  ? 'padding: 64px 0px 0px 0px;' : ''" >
        <v-container class="mt-n8" fluid>
            <v-col cols="12">
                <v-card raised>
                  <div class="iframe-container" style="overflow: hidden; padding-top: 47.00%; position: relative;">
                    <iframe id="iframemodule" :src="completeurl" style="border: 0;height: 100%;left: 0; position: absolute; top: 0; width: 100%;" allowfullscreen></iframe>
                  </div>
                </v-card>                
            </v-col>
        </v-container>
        <Dialogbox
          @redirect="redirect"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :closestatus='false'
          :redirect="true"
          v-if="dialogstatus"
        />

    </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { FETCH_INDIVIDUAL_MODULE, SAVE_USER_SLIDE_ID,RESET_STATE } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type"
export default {
  name: "ModulesDetails", 
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_INDIVIDUAL_MODULE,to.params.id);

    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  }, 
  components: {
    Dialogbox: () => import("@/components/dialog/dialog")
  },   
  computed: {
    ...mapGetters(["currentUser","individualmodule", "widthValue", "mini"]),
  },
  created () {
      if(this.individualmodule.is_subscribed === false){
        this.$router.push("/modules/"+this.individualmodule.module_id);
      } 
      else if(this.individualmodule.show_player === false) {
            this.dialogstatus=true
            this.dialogboxtitle = 'Please subscribe to course'
            this.dialogButtontitle  = 'Go to courses'
            this.$store.commit(SET_LOADING, false)  
      }
			if (window['postMessage']){
				if (window.addEventListener) {
					window.addEventListener('message', this.ReceiveMessage, false);
				}
				else {
					window.attachEvent('onmessage', this.ReceiveMessage);
				}
			}      
      this.token = encodeURIComponent('Basic '+this.currentUser.learn_lock_auth)
      this.path = this.individualmodule.module_versions.full_path
      this.endpoint = encodeURIComponent(process.env.VUE_APP_LEARNING_LOCKER)
      this.actor = encodeURIComponent('{"mbox":"mailto:'+this.currentUser.email+'","name":"'+this.currentUser.name+'","objectType":"Agent"}')
      this.completeurl = process.env.VUE_APP_PLAYER_URL+this.path+'?endpoint='+this.endpoint+'&auth='+this.token+'&actor='+this.actor
 },
 methods :{
      redirect(){
        this.$router.push('/courses')
      },  
			ReceiveMessage(evt) {
				if (evt.origin === process.env.VUE_APP_PLAYER_URL&& this.slideid != (JSON.parse(evt.data).slideid))
				{
          this.slideid  = JSON.parse(evt.data).slideid
          this.$store.dispatch(SAVE_USER_SLIDE_ID,{
            slide_id: this.slideid,
            module_id: this.individualmodule.module_id}).then(resp =>{
            if(resp.success == true){
              store.commit(SET_LOADING, false)
            }
          })
				}
      }
 },
  data() {
    return {
        token: null,
        path: null,
        endpoint: null,
        completeurl: null,
        actor:null,
        slideid: null,
        dialogstatus: false,
        dialogButtontitle: null,
        dialogboxtitle: null,

    };
  },   
}
</script>